import { z } from 'zod';

export type RoundMode = 'truncate' | 'roundUp' | 'roundDown';

export type Separator = '.' | ',';

const RoundModeValues = ['truncate', 'roundUp', 'roundDown'] as const;

const separators = ['.', ','] as const;

export type GoalViewConfig = {
  percentageOpts: {
    roundMode: RoundMode;
    decimals: number;
  };
  labelOpts?: {
    roundMode?: RoundMode;
    decimalSeparator?: Separator;
    thousandSeparator?: Separator;
    prefix?: string;
    decimals?: number;
  };
  coloring?: {
    startPercentage: number;
    endPercentage: number;
    color: string;
    default?: boolean | undefined;
  }[];
};

export const goalConfigSchema = z.object({
  percentageOpts: z.object({
    roundMode: z.enum(RoundModeValues),
    decimals: z.number(),
  }),
  labelOpts: z
    .object({
      prefix: z.string().optional(),
      decimals: z.number().optional().default(2),
      decimalSeparator: z.enum(separators).optional().default(','),
      thousandSeparator: z.enum(separators).optional().default('.'),
      roundMode: z.enum(RoundModeValues).optional().default('truncate'),
    })
    .optional(),
  coloring: z
    .array(
      z.object({
        startPercentage: z.number(),
        endPercentage: z.number(),
        color: z.string(),
        default: z.boolean().optional(),
      }),
    )
    .optional(),
});

type GoalConfigSchemaType = z.infer<typeof goalConfigSchema>;

const defaultValue: GoalConfigSchemaType = {
  coloring: [{ color: '#FFF', default: true, endPercentage: 100, startPercentage: 0 }],
  labelOpts: {
    decimals: 2,
    decimalSeparator: ',',
    thousandSeparator: '.',
    roundMode: 'truncate',
    prefix: '%',
  },
  percentageOpts: {
    decimals: 2,
    roundMode: 'truncate',
  },
};

export const goalConfigDefaultValue = JSON.stringify(defaultValue, null, '\t');
